// NEW_FILE_JUSTIFIED: Card wrapper for claim form sections with lime-green icon header — matches 4iCover .pen design

import {
  User,
  HeartPulse,
  ClipboardList,
  Stethoscope,
  List,
  Upload,
  Wallet,
  Landmark,
  ShieldCheck,
  PenLine,
  Info,
} from 'lucide-react';
import type { IClaimFormSectionCardProps } from '@/@types/claims';

const SECTION_ICONS: Record<string, React.ReactNode> = {
  user: <User className="h-5 w-5 text-[#4D7C0F]" />,
  'heart-pulse': <HeartPulse className="h-5 w-5 text-[#4D7C0F]" />,
  'clipboard-list': <ClipboardList className="h-5 w-5 text-[#4D7C0F]" />,
  stethoscope: <Stethoscope className="h-5 w-5 text-[#4D7C0F]" />,
  list: <List className="h-5 w-5 text-[#4D7C0F]" />,
  upload: <Upload className="h-5 w-5 text-[#4D7C0F]" />,
  wallet: <Wallet className="h-5 w-5 text-[#4D7C0F]" />,
  landmark: <Landmark className="h-5 w-5 text-[#4D7C0F]" />,
  'shield-check': <ShieldCheck className="h-5 w-5 text-[#4D7C0F]" />,
  'pen-line': <PenLine className="h-5 w-5 text-[#4D7C0F]" />,
  info: <Info className="h-5 w-5 text-[#D97706]" />,
};

export function ClaimFormSectionCard({
  title,
  icon,
  description,
  headerAction,
  children,
}: IClaimFormSectionCardProps) {
  return (
    <div className="rounded-xl border border-border bg-white">
      <div className="flex items-center justify-between px-6 pt-6 pb-4">
        <div className="flex items-center gap-2.5">
          {icon && SECTION_ICONS[icon] && (
            <span className="flex shrink-0">{SECTION_ICONS[icon]}</span>
          )}
          <h3 className="text-base font-semibold text-foreground">{title}</h3>
        </div>
        {headerAction}
      </div>
      <div className="mx-6 h-px bg-border" />
      {description && (
        <p className="px-6 pt-4 text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
          {description}
        </p>
      )}
      <div className="px-6 py-5 space-y-5">{children}</div>
    </div>
  );
}
